<div
  class="export-kaspacom-container flex column full-width full-height p-24 gap-32"
>
  <!-- Initial Step -->
  @if (currentStep() === "initial") {
    <div class="initial-step flex column align-items-center gap-24">
      <div class="lock-icon-container">
        <img src="svgs/lock.svg" alt="Lock icon" class="lock-icon" />
      </div>

      <div
        class="step-content flex column align-items-center gap-16 text-center"
      >
        <div class="typo-heading-2 text-white">Export Your Kaspacom Wallet</div>
        <p class="typo-text-1 text-gray-60 max-width-400">
          Export your wallet data as a QR code or download it as a secure file.
          You can use this to sync your wallets with other devices.
        </p>
      </div>

      <div class="action-buttons flex column gap-16 full-width max-width-300">
        <kc-button
          [text]="'Export wallet'"
          variant="primary"
          size="m"
          [isFullWidth]="true"
          (buttonClick)="onStartExport()"
        />
      </div>
    </div>
  }

  <!-- Password Step -->
  @if (showPasswordStep()) {
    <div class="password-step flex column align-items-center gap-24">
      <div class="lock-icon-container">
        <img src="svgs/lock.svg" alt="Lock icon" class="lock-icon" />
      </div>

      <div
        class="step-content flex column align-items-center gap-8 text-center"
      >
        <div class="typo-heading-2 text-white">Enter Your Password</div>
        <p class="typo-text-1 text-gray-60">
          Please enter your wallet password to proceed with the export
        </p>
      </div>

      <div class="password-form flex column gap-16 full-width max-width-400">
        <div class="input-group flex column gap-8">
          <kc-input
            [infoLabel]="{ label: 'Password' }"
            [type]="'password'"
            [placeholder]="'Enter your password'"
            [isValid]="!passwordError()"
            [(ngModel)]="password"
            (ngModelChange)="onPasswordInput()"
            (keyup.enter)="onVerifyPassword()"
            [isDisabled]="isLoading()"
          />
          @if (passwordError()) {
            <span class="kc-input-error-text">{{ passwordError() }}</span>
          }
        </div>

        <div class="action-buttons flex column gap-12">
          <kc-button
            [text]="'Verify Password'"
            variant="primary"
            size="m"
            [isFullWidth]="true"
            [isLoading]="isLoading()"
            [isDisabled]="!password().trim()"
            (buttonClick)="onVerifyPassword()"
          />

          <kc-button
            [text]="'Cancel'"
            variant="secondary"
            size="m"
            [isFullWidth]="true"
            [isDisabled]="isLoading()"
            (buttonClick)="onHideKeyInfo()"
          />
        </div>
      </div>
    </div>
  }

  <!-- Export Step -->
  @if (showExportStep()) {
    <div class="export-step flex column gap-24">
      <!-- QR Code Section -->
      @if (canShowQrCode()) {
        <div class="qr-section flex column align-items-center gap-20">
          <div class="qr-header text-center">
            <div class="typo-heading-3 text-white mb-8">Scan QR Code</div>
            <p class="typo-text-1 text-gray-60">
              Scan this QR code with your mobile wallet to sync your data
            </p>
          </div>

          <div class="qr-container p-16 rounded-lg bg-white">
            <qrcode
              [qrdata]="encryptedUserData()!"
              [width]="qrCodeSize()"
              [errorCorrectionLevel]="'M'"
              [elementType]="'canvas'"
              [margin]="2"
            />
          </div>

          <div class="qr-actions flex gap-12">
            <kc-button
              [text]="'Copy Data'"
              variant="secondary"
              size="m"
              (buttonClick)="onCopyQrData()"
            />
          </div>
        </div>
      }

      <!-- Data Too Big Warning -->
      @if (dataTooBig()) {
        <div class="warning-section flex column align-items-center gap-16">
          <div class="warning-box p-16 rounded-lg">
            <div class="flex align-items-start gap-12">
              <kc-icon
                iconClass="icon-warning"
                size="sm"
                class="text-warning flex-shrink-0"
              />
              <div class="warning-content">
                <p class="typo-text-1 text-warning mb-4 font-medium">
                  QR Code Not Available
                </p>
                <p class="typo-text-2 text-gray-75">
                  You have too many wallets to display in a QR code. Please use
                  the download option instead.
                </p>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Download Section -->
      <div class="download-section flex column align-items-center gap-20">
        <div class="download-header text-center">
          <div class="typo-heading-3 text-white mb-8">Download Wallet File</div>
          <p class="typo-text-1 text-gray-60">
            Download your wallet data as a secure file for backup or transfer
          </p>
        </div>

        <kc-button
          [text]="'Download Key File'"
          variant="primary"
          size="m"
          (buttonClick)="onDownloadKeyFile()"
        />
      </div>

      <!-- Actions -->
      <div class="export-actions flex column gap-12 mt-16">
        <kc-button
          [text]="'Done'"
          variant="secondary"
          size="m"
          [isFullWidth]="true"
          (buttonClick)="onHideKeyInfo()"
        />
      </div>
    </div>
  }
</div>
